export * from "./validations";
export * from "./utils";

export function getErrorResponseMessage(error: any): string {
  if (error?.response?.data) {
    return error.response.data?.message
  }
  return "An unknown error occurred"
}